// T-407: sostituti dei popup NATIVI del browser (window.confirm / window.alert),
// brutti e incoerenti tra le piattaforme, con dialog Ionic nativi + label dei
// pulsanti personalizzabili. Imperativi (Promise-based) → drop-in per il codice
// esistente: `if (confirm(x))` → `if (await confirmDialog(x))`.
import { alertController } from '@ionic/core';

export interface ConfirmOpts {
  header?: string;
  okText?: string;
  cancelText?: string;
  /** Colora il pulsante di conferma in rosso (azioni distruttive: elimina/archivia). */
  danger?: boolean;
}

/** Dialog di conferma. Ritorna true se l'utente conferma, false se annulla/chiude. */
export async function confirmDialog(message: string, opts?: ConfirmOpts): Promise<boolean> {
  const alert = await alertController.create({
    header: opts?.header,
    message,
    buttons: [
      { text: opts?.cancelText ?? 'Annulla', role: 'cancel' },
      {
        text: opts?.okText ?? 'OK',
        role: 'confirm',
        cssClass: opts?.danger ? 'alert-button-danger' : undefined,
      },
    ],
  });
  await alert.present();
  const { role } = await alert.onDidDismiss();
  return role === 'confirm';
}

/** Dialog informativo con un solo pulsante. */
export async function alertDialog(
  message: string,
  opts?: { header?: string; okText?: string },
): Promise<void> {
  const alert = await alertController.create({
    header: opts?.header,
    message,
    buttons: [{ text: opts?.okText ?? 'OK', role: 'cancel' }],
  });
  await alert.present();
  await alert.onDidDismiss();
}
